import produce from "immer";

const trackAppointmentReducer = (state, action) => {
  switch (action.type) {
    case "SET_VERIFY_ERROR": {
      return produce(state, (draft) => {
        draft.verifyError = action.payload.verifyError;
      });
    }

    case "SET_IS_VERIFYING": {
      return produce(state, (draft) => {
        draft.isVerifying = action.payload.isVerifying;
      });
    }

    case "SET_APPOINTMENT": {
      return produce(state, (draft) => {
        draft.appointment = action.payload.appointment;
      });
    }

    case "SET_IS_SUBMITTING": {
      return produce(state, (draft) => {
        draft.isSubmitting = action.payload.isSubmitting;
      });
    }

    case "SET_SUBMITTING_ERROR": {
      return produce(state, (draft) => {
        draft.submittingError = action.payload.submittingError;
      });
    }

    case "SET_SUBMITTING_MESSAGE": {
      return produce(state, (draft) => {
        draft.submittingMessage = action.payload.submittingMessage;
      });
    }

    default:
      throw new Error();
  }
};

export default trackAppointmentReducer;
